import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { purpose1, purpose2, purpose3, purpose4, v5 } from "../images";

const VedioCard = () => {
  const [currentImage, setCurrentImage] = useState(0);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const carouselItems = [
    {
      id: 1,
      imageUrl: purpose1,
      videoLink: 'https://drive.google.com/drive/folders/1JvYCp2kNR6Di2zbljYpMftGKxTYVbKWr', // Add video link for image 1
    },
    {
      id: 2,
      imageUrl: purpose2,
      videoLink: 'https://drive.google.com/file/d/1sYX1N5aaFftY5MG9oAULbt4D7yIUIRLk/view?usp=drive_link', // Add video link for image 2
    },
    {
      id: 3,
      imageUrl: purpose3,
      videoLink: 'https://drive.google.com/file/d/16XZyRopkQd226gWqD3wXaHkfirj26vYo/view?usp=drive_link', // Add video link for image 3
    },
    {
      id: 4,
      imageUrl: purpose4,
      videoLink: 'https://drive.google.com/file/d/1guHq7sR6cgGmwPgQOoNXtW8iaD_fzKU4/view?usp=drive_link', // Add video link for image 4
    },
    {
      id: 5,
      imageUrl: v5,
      videoLink: 'https://drive.google.com/file/d/1ZuDqygPZn7mHQ8p-hwW2YGrRV72dOI-2/view?usp=drive_link', // Add video link for image 5
    },
  ];

  const handleNextImage = () => {
    setCurrentImage((prevImage) => (prevImage + 1) % carouselItems.length);
  };

  const handlePrevImage = () => {
    setCurrentImage((prevImage) =>
      prevImage === 0 ? carouselItems.length - 1 : prevImage - 1
    );
  };

  const handleWatchVideo = () => {
    // Open the video link in a new tab or window
    window.open(carouselItems[currentImage].videoLink, '_blank');
  };

  return (
    <div className="vedio-card-container">
      <Carousel
        swipeable={false}
        draggable={false}
        showDots={true}
        responsive={responsive}
        ssr={true} // Server-side rendering support
        infinite={true}
        autoPlay={true} // Enable autoplay
        autoPlaySpeed={3000} // Set autoplay interval to 3 seconds
        keyBoardControl={true}
        customTransition="transform 300ms ease-in-out"
      >
        {carouselItems.map((item) => (
          <div key={item.id} className="carousel-image">
            <video
              controls
              src={item.videoLink}
              poster={item.imageUrl}
              width="400"
              height="300"
            />
            <button className="watch-button" onClick={handleWatchVideo}>
              Watch
            </button>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default VedioCard;
